import { ObjectSelector, SelectedItems } from '../selector/selector';
import React from 'react';
import useAppContext from '../../../../context/useAppContext';
import Contingent from '../../../../models/contingentModel';
import { useTranslation } from 'react-i18next';

/**
 * Contingent Selector.
 * Used to select a contingent or many contingents
 * @param contingents - list contingents objects (not ids)
 * @param eventsSelectedObjects - Current event object
 * @param onchange - function to perform on actions
 * @param many - boolean to know if we have to select many events or not
 */
export function ContingentSelector({ contingents, eventsSelectedObjects, onChange, many = false }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    if (!eventsSelectedObjects?.chart) {
        return null;
    }
    return (
        <ObjectSelector
            objects={contingents}
            Model={Contingent}
            requestParams={{ organizationId: organization.id, eventId: eventsSelectedObjects?.pk, launch: Boolean(eventsSelectedObjects?.chart) }}
            onChange={onChange}
            many={many}
            requestDeps={[eventsSelectedObjects]}
            label={t('ticket.widget.singleEvent.titleContingent')}
            placeholder={t('ticket.widget.singleEvent.placeholderContingent')}
        >
            {many === true && (
                <SelectedItems
                    objects={contingents}
                    onRemoveObject={obj => {
                        let tmp_tab = [...contingents];
                        let index = tmp_tab.findIndex(object => object.pk === obj.pk);
                        tmp_tab.splice(index, 1);
                        return onChange(tmp_tab);
                    }}
                    name={t('ticket.widget.singleEvent.selectedContingents')}
                />
            )}
        </ObjectSelector>
    );
}
